import { ColorSelectorStoryblok } from '../types/bloks/colorSelector';

export function getColorFromStory(story: ColorSelectorStoryblok[]) {
  return story?.[0]?.color?.content?.color?.color;
}
